import { Category as ProtoCategory } from '@italist/grpc-proto/entities/category_pb';
import Departments from '../../models/departments';
import { Category } from '../../models/category';

const normalizeCategoryName = name => {
  const normalized = name.replace(/[^a-zA-Z0-9]/g, '-');
  return normalized.replace(/-+/g, '-');
};

const getParentPath = (protoCategory: ProtoCategory, protoCategoryList: ProtoCategory[]): string => {
  const name = normalizeCategoryName(protoCategory.getName());
  let catUrl = `${name.toLowerCase()}`;
  if (protoCategory.getParentId() !== '') {
    const parentCategory = protoCategoryList.find(c => c.getId() === protoCategory.getParentId());
    const parentPath = getParentPath(parentCategory, protoCategoryList);
    catUrl = `${parentPath}/${catUrl}`;
  }
  return catUrl;
};

export const decorateCategory = (protoCategory: ProtoCategory, protoCategoryList: ProtoCategory[]): Category => {
  const category = protoCategory.toObject();
  const isKids = Departments.getKidsDepartmentsInternalNames().includes(category.department?.internalName);
  const kidsPrefix = isKids ? '/kids' : '';
  const categoriesPath = getParentPath(protoCategory, protoCategoryList);
  const url =
    protoCategory.getParentId() !== '' || isKids
      ? `${kidsPrefix}/${categoriesPath}/${protoCategory.getId()}/`
      : `${kidsPrefix}/${categoriesPath}/`;
  return {
    ...category,
    url,
  };
};
